import { useState } from 'react';

export const useControlledValue = <T>(valueFromProps: T | undefined, onChangeFromProps: ((newValue: T) => void) | undefined, defaultValue?: T) => {
   const isControlled = typeof valueFromProps !== 'undefined';

   const [internalValue, setInternalValue] = useState(defaultValue);

   const value = isControlled ? valueFromProps : internalValue;

   const setValue = (newValue: T) => {
      if (onChangeFromProps) {
         onChangeFromProps(newValue);
      }

      if (!isControlled) {
         setInternalValue(newValue);
      }
   };

   return [value as T, setValue] as const;
};
